"use strict";
/** Схемы поиска и экспорта. */
Object.defineProperty(exports, "__esModule", { value: true });
exports.exportQuerySchema = exports.searchQuerySchema = void 0;
const zod_1 = require("zod");
exports.searchQuerySchema = zod_1.z.object({
    q: zod_1.z.string().trim().min(2, 'Запрос не короче двух символов').max(200, 'Запрос слишком длинный'),
    /** Сколько находок вернуть в каждой группе. */
    limit: zod_1.z.coerce.number().int().min(1).max(50).default(10),
});
exports.exportQuerySchema = zod_1.z.object({
    format: zod_1.z.enum(['json', 'markdown']).default('json'),
});
//# sourceMappingURL=search.js.map